export const GET_EXEC_HISTORY = 'GET_EXEC_HISTORY';
export const SET_EXEC_HISTORY = 'SET_EXEC_HISTORY';
export const ERROR_EXEC_HISTORY = 'ERROR_EXEC_HISTORY';